import type { SingleItemState, SingleItemErrorState } from "../types";

const defaultNewItem = (): SingleItemState => ({
  name: "",
  parent: null,
  children: null,
  serialNumber: null,
  type: null,
  status: null,
  internalNumber: null,
  user: null,
  history: null,
  costCenter: null,
  bought: null,
  notes: null,
  location: null,
  warrantyUntil: null,
  invoiceNumber: null,
  extendedWarranty: null,
  inventoryCheck: null,
  tags: [],
  createdAt: null,
});

const defaultNewItemErrorState: SingleItemErrorState = {
  name: false,
  parent: false,
  children: false,
  serialNumber: false,
  type: false,
  status: false,
  costCenter: false,
  internalNumber: false,
  user: false,
  bought: false,
  warrantyUntil: false,
  extendedWarranty: false,
};

export { defaultNewItem, defaultNewItemErrorState };
